export default {
  meta: {
    title: "DADABIO 创新科技",
    desc: "DADABIO——总部位于伊斯坦布尔的研发驱动型软件工程公司，为全球企业构建高性能企业软件、先进人工智能生态系统和安全的跨境数字平台。",
  },
  nav: { vision: "愿景", services: "服务", contact: "联系我们", cta: "启动项目" },
  hero: {
    badge: "伊斯坦布尔 → 全球 · 研发工程公司",
    lines: ["DADABIO", "创新", "科技"],
    subtitle: "为全球企业构建高性能企业软件、先进的人工智能生态系统以及安全的跨境数字平台。",
    ctaPrimary: "探索服务",
    ctaSecondary: "启动项目",
    scroll: "滚动",
  },
  marquee: ["企业软件", "人工智能生态系统", "跨境平台", "零信任安全", "前沿研发", "全球规模"],
  vision: {
    label: "Kurumsal Vizyon — Corporate Vision",
    heading: "构建全球商业的隐形基础设施",
    p1: "DADABIO 是一家以研发为驱动的软件工程公司，总部位于伊斯坦布尔，致力于人工智能、企业系统与跨境数字基础设施的交汇领域。我们不追随技术周期——我们构建周期之后的未来。",
    p2: "我们交付的每一个平台都建立在三个毫不妥协的原则之上：规模化性能、设计即安全、可衡量的商业价值。从进入全球市场的初创企业，到进行现代化改造的大型企业，我们将雄心勃勃的愿景转化为生产级的现实。",
    chapters: [
      { num: "01", title: "研发为核心", text: "在 DADABIO，研究不是一个部门——而是操作系统。我们的工程师在新兴技术进入生产路线图之前，就已完成原型设计、基准测试和加固。" },
      { num: "02", title: "创新驱动型架构", text: "精干、资深、自主的团队。从创意到部署之间没有官僚主义。这种架构让我们以初创企业的速度和大企业的纪律前行。" },
      { num: "03", title: "全球转型", text: "通过高科技集成，我们重塑全球企业的运营方式——将市场、货币和数据连接成一个连贯的数字生命体。" },
    ],
    stats: [
      { value: "6+", label: "全球市场" },
      { value: "120+", label: "企业级部署" },
      { value: "99.9%", label: "可用性 SLA" },
      { value: "24/7", label: "安全监控" },
    ],
  },
  services: {
    label: "我们的业务",
    heading: "六大领域，一种执着。",
    sub: "点击任意领域，查看完整能力说明。",
    items: [
      { num: "01", title: "企业应用支持", tagline: "关键业务系统的全生命周期支持", detail: "我们在整个生命周期内运营关键业务应用——从主动事件响应、SLA 跟踪的服务台，到云迁移和持续的性能优化。您的系统始终保持快速、稳定，并领先于需求。", points: ["全生命周期技术支持", "SLA 跟踪与报告", "云迁移架构", "持续系统优化"] },
      { num: "02", title: "前沿技术研发", tagline: "定制大语言模型、视觉系统、深度科技", detail: "我们的研究实验室设计定制化的大语言模型架构，微调机器学习模型，并构建将原始数据转化为决定性优势的计算机视觉管线。深度科技创新，为生产环境而工程化。", points: ["定制 LLM 架构", "机器学习模型微调", "计算机视觉系统", "深度科技原型开发"] },
      { num: "03", title: "国际电子商务", tagline: "无国界贸易，全球化规模", detail: "我们构建高容量的跨境商务平台，配备多币种支付管线、本地化店铺和全球数字贸易物流——为跨市场无摩擦扩展而生。", points: ["跨境商务架构", "多币种支付管线", "全球贸易物流", "本地化店铺系统"] },
      { num: "04", title: "定制软件工程", tagline: "生产级平台，经久耐用", detail: "可扩展的微服务、精密的后端工程和强化的 API 开发——以安全的、生产就绪的架构交付，与您的企业共同成长。", points: ["可扩展微服务", "后端系统工程", "API 设计与开发", "生产级交付"] },
      { num: "05", title: "数字化转型咨询", tagline: "从传统流程到智能系统", detail: "我们通过工作流自动化、应用数据科学和战略性技术集成重塑企业运营——将传统流程转变为智能、可衡量的系统。", points: ["企业工作流自动化", "数据科学实施", "战略技术集成", "传统系统现代化"] },
      { num: "06", title: "网络安全与云运营", tagline: "零信任防御，全天候运营", detail: "零信任网络部署、加密云架构和 24/7 主动监控，确保您的基础设施坚不可摧。我们在风险酿成影响之前将其识别。", points: ["零信任部署", "加密云架构", "风险缓解", "24/7 服务器监控"] },
    ],
  },
  contact: {
    label: "联系我们",
    heading: "让我们共建未来。",
    sub: "告诉我们您的项目——资深工程师将在一个工作日内回复。",
    namePlaceholder: "姓名",
    emailPlaceholder: "企业邮箱",
    subjectPlaceholder: "主题",
    messagePlaceholder: "请告诉我们您的项目...",
    send: "发送消息",
    sending: "发送中...",
    successTitle: "消息已收到。",
    successMsg: "我们的团队将在一个工作日内回复。",
    error: "出现问题，请重试。",
  },
  footer: {
    tagline: "构建全球商业的数字基础设施。",
    hq: "Rumeli Cad. No 7/4 Basaksehir / Istanbul - TURKIYE",
    duns: "D-U-N-S®: 75-116-1145",
    privacy: "隐私政策",
    terms: "服务条款",
    rights: "© 2026 DADABIO İnovasyon Teknoloji。版权所有。",
  },
};
